import {http, onFail, onSuccess} from './http';

export const getMembers = (clientId, params, eventKey) =>
    http.get(`/api/cp/event/${eventKey}/member`, {params: {...params, clientId}})
        .then(onSuccess, onFail);

export const getMember = (id) =>
    http.get(`/api/cp/event/member/${id}`)
        .then(onSuccess, onFail);

export const createMember = (clientId, data, eventKey) =>
    http.post(`/api/cp/event/${eventKey}/member`, {...data, clientId})
        .then(onSuccess, onFail);

export const updateMember = (id, data) =>
    http.put(`/api/cp/event/member/${id}`, data)
        .then(onSuccess, onFail);

export const deleteMember = (id) =>
    http.delete(`/api/cp/event/member/${id}`)
        .then(onSuccess, onFail);

export const updateMemberPhoto = (id, file) => {
    const formData = new FormData();
    formData.append('photo', file);
    return http.post(`/api/cp/event/member/${id}/photo`, formData)
        .then(onSuccess, onFail);
}

// Participations
export const getEventMembers = (eventKey) => {
    return http.get(`/api/cp/event/${eventKey}/members`)
        .then(onSuccess, onFail);
};

export const createEventMember = (eventKey, payload) => {
    return http.post(`/api/cp/event/${eventKey}/members`, payload)
        .then(onSuccess, onFail);
};

export const updateEventMember = (memberId, payload) => {
    return http.post(`/api/cp/event/members/${memberId}`, payload)
        .then(onSuccess, onFail);
};

export const deleteEventMember = (memberId) => {
    return http.delete(`/api/cp/event/members/${memberId}`)
        .then(onSuccess, onFail);
};

export const updateEventMembersOrder = (eventKey, payload) => {
    return http.post(`/api/cp/event/${eventKey}/members-order`, {sortOrder: payload})
        .then(onSuccess, onFail);
};

export const clearMembersList = (eventKey) => {
    return http.post(`/api/cp/event/${eventKey}/members/clear`)
        .then(onSuccess, onFail);
};

// Roles
export const getEventRoles = (eventKey) => {
    return http.get(`/api/cp/event/${eventKey}/roles`)
        .then(onSuccess, onFail);
};

export const createEventRoles = (eventKey, payload) => {
    return http.post(`/api/cp/event/${eventKey}/roles`, payload)
        .then(onSuccess, onFail);
};

export const updateEventRoles = (eventRole, payload) => {
    return http.post(`/api/cp/event/roles/${eventRole}`, payload)
        .then(onSuccess, onFail);
};

export const deleteEventRoles = (eventRole) => {
    return http.delete(`/api/cp/event/roles/${eventRole}`)
        .then(onSuccess, onFail);
};

// Participant Tags
export const createMemberTag = (memberId, eventTag) => {
    return http.post(`/api/cp/event/members/${memberId}/tag/${eventTag}`)
        .then(onSuccess, onFail);
};

export const deleteMemberTag = (memberId, eventTag) => {
    return http.delete(`/api/cp/event/members/${memberId}/tag/${eventTag}`)
        .then(onSuccess, onFail);
};

export const updateMemberTagsOrder = (memberId, payload) => {
    return http.post(`/api/cp/event/members/${memberId}/tag-order`, {sortOrder: payload})
        .then(onSuccess, onFail);
};

// Member roles
export const createMembertRole = (memberId, eventRole) => {
    return http.post(`/api/cp/event/members/${memberId}/role/${eventRole}`)
        .then(onSuccess, onFail);
};

export const deleteMemberRole = (memberId, eventRole) => {
    return http.delete(`/api/cp/event/members/${memberId}/role/${eventRole}`)
        .then(onSuccess, onFail);
};

export const updateMemberRolesOrder = (memberId, payload) => {
    return http.post(`/api/cp/event/members/${memberId}/role-order`, {sortOrder: payload})
        .then(onSuccess, onFail);
};

// Members import
export const importMembersList = (eventKey, file) => {
    return http.post(`/api/cp/event/${eventKey}/importMembers`, file)
        .then(onSuccess, onFail);
};

// Member hide
export const updateMembersGroupAction = (eventKey, payload) => {
    return http.post(`/api/cp/event/${eventKey}/members/group-action`, payload)
        .then(onSuccess, onFail);
};
